import React from 'react'
import styled from 'styled-components'
import {
  BaseColorType,
  Flex,
  Icon,
  borderRadius,
  color,
  getColorsFromBaseColor,
  padding,
  shadow,
} from '@evrekadev/evreka-ui-components'
import { Typography } from 'components'
import { UilArrowRight } from '@iconscout/react-unicons'
import { useTranslation } from 'utils/useTranslation'

export type StarterProps = {
  title: string
  description: string
  onClick: () => void
  icon: React.ReactNode
  color?: BaseColorType
  isSecondary?: boolean
}

export const Starter: React.FC<StarterProps> = ({
  description,
  title,
  onClick,
  icon,
  color,
  isSecondary,
}) => {
  const { t } = useTranslation('pages.ai.starters')
  return (
    <StarterStyled isSecondary={isSecondary} onClick={onClick} color={color}>
      {icon}
      <Flex
        directionColumn="zero"
        style={{
          flexGrow: 1,
        }}
      >
        <Typography fontSize="text_md" fontWeight="medium" color={'grey900'}>
          {t(title)}
        </Typography>
        <Typography fontSize="text_sm" fontWeight="regular" color={'grey600'}>
          {t(description)}
        </Typography>
      </Flex>
      {!isSecondary && (
        <Icon
          className="arrow"
          icon={UilArrowRight}
          size={32}
          color={color ? getColorsFromBaseColor(color).border : 'grey400'}
        />
      )}
    </StarterStyled>
  )
}

const StarterStyled = styled.div<{ color?: BaseColorType; isSecondary?: boolean }>`
  ${padding([16])}
  ${borderRadius(8)}
  ${shadow('xs')}
  background-color: ${({ color: assistantColor, isSecondary }) =>
    color(
      isSecondary
        ? 'grey100'
        : assistantColor
          ? getColorsFromBaseColor(assistantColor).background
          : 'white',
    )};
  border: 1px solid
    ${({ color: assistantColor }) =>
      color(assistantColor ? getColorsFromBaseColor(assistantColor).border : 'grey200')};
  transition: all 0.2s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  svg {
    transition: all 0.2s;
  }

  .arrow {
    transition: all 0.2s;
  }

  &:hover {
    ${shadow('md')}
    .arrow {
      fill: ${color('grey600')};
    }

    svg {
      scale: 1.1;
    }
  }

  p {
    margin: 0;
  }
`
